// Marco Polo Security — brand imagery (uploaded by client)
export const IMAGES = {
  logo:
    "https://customer-assets.emergentagent.com/job_secure-patrol-5/artifacts/aw2m6cp8_Black%20and%20White%20Modern%20Security%20Logo.png",
  heroSecurity:
    "https://customer-assets.emergentagent.com/job_secure-patrol-5/artifacts/sj0ldsdd_ChatGPT%20Image%20Jul%208%2C%202026%2C%2001_47_52%20PM.png",
  fleetGroup:
    "https://customer-assets.emergentagent.com/job_secure-patrol-5/artifacts/c79xiy3g_ChatGPT%20Image%20Jul%208%2C%202026%2C%2005_16_26%20PM.png",
  vehicleRear:
    "https://customer-assets.emergentagent.com/job_secure-patrol-5/artifacts/ku161yvp_ChatGPT%20Image%20Jul%208%2C%202026%2C%2005_49_39%20PM.png",
  officerInStore:
    "https://customer-assets.emergentagent.com/job_secure-patrol-5/artifacts/vzn1srfe_608D4286-B28D-4987-8F41-46787BF3083C.jpeg",
};
